export const SleepTipsRelaxationStoriesData = [
  {
    id: 1,
    src: require('../../pages/SleepTipsPage/img-sleep-tips/physical-relaxation/tip1.png'),
    recommendation: 'Before going to bed, you can increase the quality of your sleep by stretching and engaging in meditative exercises.',
  },
  {
    id: 2,
    src: require('../../pages/SleepTipsPage/img-sleep-tips/physical-relaxation/tip2.png'),
    recommendation: 'Keep the bedroom at a pleasant, cool temperature by having access to fresh air.',
  },
  {
    id: 3,
    src: require('../../pages/SleepTipsPage/img-sleep-tips/physical-relaxation/tip3.png'),
    recommendation: 'Keep your phone away before sleep. It emits blue light, which is similar to sunlight. This kind of light can keep you up at night because it tricks your brain into thinking it’s daytime.',
  },
  {
    id: 4,
    src: require('../../pages/SleepTipsPage/img-sleep-tips/physical-relaxation/tip4.png'),
    recommendation: 'Before bed, try taking some deep breaths to clear your mind.',
  },
  {
    id: 5,
    src: require('../../pages/SleepTipsPage/img-sleep-tips/physical-relaxation/tip5.png'),
    recommendation: 'Try to go to bed and wake up at the same time every day, even on weekends.',
  },
  {
    id: 6,
    src: require('../../pages/SleepTipsPage/img-sleep-tips/physical-relaxation/tip6.png'),
    recommendation: 'Before bed, dream about the things that you look forward to in your life. It will help you fall asleep more easily.',
  },
  {
    id: 7,
    src: require('../../pages/SleepTipsPage/img-sleep-tips/physical-relaxation/tip7.png'),
    recommendation: 'Getting in the habit of taking a warm shower before bed and drinking a glass of warm milk can help you relax.',
  },
  {
    id: 8,
    src: require('../../pages/SleepTipsPage/img-sleep-tips/physical-relaxation/tip8.png'),
    recommendation: 'Before you go to bed, think about things that make you happy rather than sad.',
  },
  {
    id: 9,
    src: require('../../pages/SleepTipsPage/img-sleep-tips/physical-relaxation/tip9.png'),
    recommendation: 'Do not eat a heavy meal before going to bed, and do not starve yourself either.',
  },
  {
    id: 10,
    src: require('../../pages/SleepTipsPage/img-sleep-tips/physical-relaxation/tip10.png'),
    recommendation: 'Choose comfortable bedding so that you are neither hot nor cold.',
  }
];

export const BetterSleepTipsStoriesData = [
  {
    id: 1,
    src: require('../../pages/SleepTipsPage/img-sleep-tips/better-sleep/tip1.png'),
    recommendation: 'When your shoulder hurts, don\'t sleep on it; instead, sleep on your back with a pillow hugged to your chest.',
  },
  {
    id: 2,
    src: require('../../pages/SleepTipsPage/img-sleep-tips/better-sleep/tip2.png'),
    recommendation: 'If you often suffer from heartburn, try sleeping on your left side with your head propped up by a big pillow.',
  },
  {
    id: 3,
    src: require('../../pages/SleepTipsPage/img-sleep-tips/better-sleep/tip3.png'),
    recommendation: 'To relieve back pain, try placing an extra pillow between your legs before going to bed.',
  },
  {
    id: 4,
    src: require('../../pages/SleepTipsPage/img-sleep-tips/better-sleep/tip4.png'),
    recommendation: 'When heartache hits, try not to sleep on your side — this position can strain your heart. Lying on your back and a deep breath can ease the pain.',
  },
  {
    id: 5,
    src: require('../../pages/SleepTipsPage/img-sleep-tips/better-sleep/tip5.png'),
    recommendation: 'Neck pain. Change your pillows often and prefer latex ones.',
  },
  {
    id: 6,
    src: require('../../pages/SleepTipsPage/img-sleep-tips/better-sleep/tip6.png'),
    recommendation: 'Lower back pain. Right before sleeping, bend your legs and place a pillow between them.',
  },
  {
    id: 7,
    src: require('../../pages/SleepTipsPage/img-sleep-tips/better-sleep/tip7.png'),
    recommendation: 'Try to sleep on your back. This posture is the most suitable for the body.',
  },
  {
    id: 8,
    src: require('../../pages/SleepTipsPage/img-sleep-tips/better-sleep/tip8.png'),
    recommendation: 'If you have a stuffy nose, use a higher pillow. Lie on the back with your head as high as possible.',
  }
];